import { Action, createReducer, on } from '@ngrx/store';
import { IUser } from '../../models/User';
import * as AuthenticationActions from '../actions/';
import { PageState } from '../../models/PageState';

const initialState: AuthenticationState = {
  user: null,
  getAuthUserLoading: PageState.Init,
};

export interface AuthenticationState {
  user: IUser | null | undefined;
  getAuthUserLoading: PageState;
}

export const authenticationState = createReducer(
  initialState,
  on(AuthenticationActions.AuthenticationUiActions.GetAuthUser, (state) => {
    return {
      ...state,
      getAuthUserLoading: PageState.Loading,
    };
  }),
  on(AuthenticationActions.AuthenticationApiActions.GetAuthUserSuccess, (state, { user }) => {
    return {
      ...state,
      user,
      getAuthUserLoading: PageState.Loaded,
    };
  }),
  on(AuthenticationActions.AuthenticationApiActions.GetAuthUserError, (state) => {
    return {
      ...state,
      getAuthUserLoading: PageState.Error,
    };
  }),
  on(AuthenticationActions.AuthenticationUiActions.LogUserOut, (state) => {
    return {
      ...state,
      user: undefined,
    };
  }),
  on(AuthenticationActions.AuthenticationApiActions.LogoutUserSuccess, () => {
    // Reset to initial state when logout is successful
    return initialState;
  })
);

export function AuthenticationReducer(state: AuthenticationState = initialState, action: Action): AuthenticationState {
  return authenticationState(state, action);
}
